/* Changelog: neuester Eintrag hervorgehoben + Mehrfach-Filter (Dropdown mit Chips) */
(function () {
  'use strict';

  var KINDS = ['app', 'firmware'];
  var TYPES = ['feature', 'fix'];

  function init(root) {
    if (!root || root.dataset.clReady === '1') return;
    root.dataset.clReady = '1';

    var entries = Array.prototype.slice.call(root.querySelectorAll('[data-cl-entry]'));
    var opts = Array.prototype.slice.call(root.querySelectorAll('[data-filter]'));
    var chips = root.querySelector('[data-cl-chips]');
    var ddBtn = root.querySelector('[data-cl-ddbtn]');
    var ddPanel = root.querySelector('[data-cl-ddpanel]');
    var resetBtn = root.querySelector('[data-cl-reset]');
    var empty = root.querySelector('[data-cl-empty]');
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var active = {}; /* { app: true, fix: true, ... } */

    /* ---- Fokus: immer der neueste sichtbare Eintrag (roter Punkt, grosses Datum). Kein Scroll-Tracking. ---- */
    function updateFocus() {
      var first = null;
      entries.forEach(function (el) {
        if (!first && !el.classList.contains('is-hidden')) first = el;
      });
      entries.forEach(function (el) {
        var on = el === first;
        el.style.setProperty('--f', on ? '1' : '0');
        if (on) el.setAttribute('data-focus', '1');
        else el.removeAttribute('data-focus');
      });
    }

    function requestUpdate() { updateFocus(); }

    /* ---- Filter ---- */
    function activeIn(list) {
      return list.filter(function (k) { return !!active[k]; });
    }

    function applyFilter() {
      var kinds = activeIn(KINDS);
      var types = activeIn(TYPES);
      var shown = 0;

      entries.forEach(function (entry) {
        var eKinds = (entry.dataset.kinds || '').split(' ');
        var eTypes = (entry.dataset.types || '').split(' ');

        var show = true;
        if (kinds.length && !kinds.some(function (k) { return eKinds.indexOf(k) >= 0; })) show = false;
        if (types.length && !types.some(function (t) { return eTypes.indexOf(t) >= 0; })) show = false;

        /* Karten: Thema (App/Firmware) und Kategorien aus den Theme-Editor-Haekchen (data-types) */
        var cardsVisible = 0;
        Array.prototype.forEach.call(entry.querySelectorAll('[data-cl-card]'), function (card) {
          var cardShow = !kinds.length || kinds.indexOf(card.dataset.kind) >= 0;
          if (cardShow && types.length) {
            var cTypes = (card.dataset.types || '').split(' ');
            cardShow = types.some(function (t) { return cTypes.indexOf(t) >= 0; });
          }
          card.classList.toggle('is-hidden', !cardShow);
          if (cardShow) cardsVisible++;
        });
        if (cardsVisible === 0) show = false;

        var wasHidden = entry.classList.contains('is-hidden');
        entry.classList.toggle('is-hidden', !show);
        if (show) {
          shown++;
          if (wasHidden && !reduceMotion) {
            entry.classList.remove('is-entering');
            void entry.offsetWidth;
            entry.classList.add('is-entering');
          }
        }
      });

      if (empty) empty.hidden = shown > 0;
      requestUpdate();
    }

    function renderChips() {
      if (!chips) return;
      chips.innerHTML = '';
      var any = false;
      opts.forEach(function (opt) {
        var key = opt.dataset.filter;
        var on = !!active[key];
        opt.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (!on) return;
        any = true;
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'cl__chip';
        chip.dataset.chip = key;
        var dot = opt.querySelector('.cl__pill-dot');
        if (dot) chip.appendChild(dot.cloneNode(true));
        chip.appendChild(document.createTextNode(opt.textContent.trim()));
        chip.insertAdjacentHTML(
          'beforeend',
          '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l8 8M14 6l-8 8"/></svg>'
        );
        chip.addEventListener('click', function () { toggle(key, false); });
        chips.appendChild(chip);
      });
      if (resetBtn) resetBtn.hidden = !any;
    }

    function toggle(key, force) {
      var next = typeof force === 'boolean' ? force : !active[key];
      if (next) active[key] = true; else delete active[key];
      renderChips();
      applyFilter();
    }

    function openDd(open) {
      if (!ddBtn || !ddPanel) return;
      ddPanel.hidden = !open;
      ddBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () { toggle(opt.dataset.filter); });
    });

    if (ddBtn) {
      ddBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        openDd(ddPanel.hidden);
      });
    }

    if (ddPanel) {
      ddPanel.addEventListener('click', function (e) { e.stopPropagation(); });
    }

    document.addEventListener('click', function () { openDd(false); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') openDd(false);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        active = {};
        renderChips();
        applyFilter();
      });
    }

    renderChips();
    updateFocus();

    root.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cl-toggle]');
      if (!btn || !root.contains(btn)) return;
      var card = btn.closest('.cl-card');
      var more = card && card.querySelector('[data-cl-more]');
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      btn.setAttribute('aria-label', open ? (btn.dataset.labelMore || '') : (btn.dataset.labelLess || ''));
      if (more) more.hidden = open;
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-changelog]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Theme Editor */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-changelog]') : null;
    if (root) { root.dataset.clReady = ''; init(root); }
  });

  document.addEventListener('shopify:block:select', function (e) {
    var block = e.target;
    if (block && block.hasAttribute && block.hasAttribute('data-cl-entry')) {
      try { block.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (err) {}
    }
  });
})();
